import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ComponentNames } from '@core/const';
import { MobileMenuFacade } from '@main/mobile-menu/data-access';
import { DeviceService } from '@shared/services';
import { HamburgerMenuService } from '@spartacus/storefront';
import { Observable, combineLatest } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Component({
  selector: 'sd-custom-hamburger-menu',
  templateUrl: './custom-hamburger-menu.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CustomHamburgerMenuComponent implements OnInit {
  isActive$: Observable<boolean>;

  constructor(
    private hamburgerMenuService: HamburgerMenuService,
    private mobileMenuFacade: MobileMenuFacade,
    public deviceService: DeviceService,
  ) {}

  ngOnInit(): void {
    this.isActive$ = combineLatest({
      isExpanded: this.hamburgerMenuService.isExpanded,
      isMatch: this.mobileMenuFacade.isRootMatch(ComponentNames.MobileMainMenu),
    }).pipe(map(({ isExpanded, isMatch }) => isExpanded && isMatch));
  }

  onToggle(): void {
    combineLatest({
      isMatch: this.mobileMenuFacade.isRootMatch(ComponentNames.MobileMainMenu),
      isExpanded: this.hamburgerMenuService.isExpanded,
    })
      .pipe(take(1))
      .subscribe(({ isMatch, isExpanded }) => {
        if (isMatch && isExpanded) {
          this.mobileMenuFacade.resetSteps();

          return;
        }

        if (!isExpanded) {
          this.hamburgerMenuService.toggle();
        }

        this.mobileMenuFacade.openMobileMenu({
          componentName: ComponentNames.MobileMainMenu,
        });
      });
  }
}
